import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { Link } from "react-router-dom";
import { logotext, socialprofils } from "../content_option";
import logoImage from "../assets/videos/MIHmid.png"
import close from "../assets/videos/close.png"
import Themetoggle from "../components/themetoggle";
// import MidLogo from "../assets/videos/MIHmid.png";
import MidLogo from "../assets/videos/MIHLogo.png"
const Headermain = () => {
  const [isActive, setActive] = useState("false");
  const [showMidLogo, setShowMidLogo] = useState(true);
  const menuRef = useRef(null);

  const handleToggle = () => {
    setActive((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setActive(true);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowMidLogo(false);
      } else {
        setShowMidLogo(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Manage the overflow hidden class based on isActive state
    if (!isActive) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [!isActive]);

  return (
    <>
      <header className="fixed-top site__header">
        <div className="d-flex align-items-center justify-content-between">
          <Link className="navbar-brand nav_ac" to="/">
            <img
              src={logoImage}
              style={{
                marginTop: "15px",
                width: "48px",

              }}
            />
          </Link>

          <Link to="/">
          {showMidLogo && (
            <img src={MidLogo} alt="Mid Logo" className="mid-logo" />
          )}
        </Link>


          <div className="d-flex align-items-center">

            <button className="menu__button  nav_ac" onClick={handleToggle}>
              {!isActive ? (
                <span>
                  <img
                    src={close}
                    style={{
                      width: "25px"
                    }}
                  />

                </span>
              ) : (
                <div className="menuTransition">
                  <span style={{ fontFamily: '"Bodoni Moda", serif', fontWeight: 400 }}>EXPLORE</span>
                  <span style={{ fontFamily: 'Domine, serif', fontWeight: 300 }}>EXPLORE</span>
                </div>

              )}
            </button>
          </div>
        </div>

        <div className={`site__navigation ${!isActive ? "menu__opend" : ""}`} ref={menuRef}>
          <div className="bg__menu h-100">
            <div className="menu__wrapper">
              <div className="menu__container p-3">
                <ul className="the_menu">
                  <li className="menu_item ">
                    <Link onClick={handleToggle} to="/" className="my-3">
                      Home
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/photo-gallery" className="my-3">
                      {" "}
                      Gallery
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/gallery" className="my-3">
                      {" "}
                      Moving Arts
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/contact" className="my-3">
                      {" "}
                      Get in Touch
                    </Link>
                  </li>
                  <li className="menu_item">
                    <Link onClick={handleToggle} to="/faqs" className="my-3">
                      {" "}
                      FAQ
                    </Link>
                  </li>
                  {/* <li className="menu_item">
                    <Link onClick={handleToggle} to="/investment" className="my-3">
                      {" "}
                      INVESTMENT
                    </Link>
                  </li> */}


                </ul>
              </div>
            </div>
          </div>

        </div>
      </header>
    </>
  );
};

export default Headermain;
